import { render } from "./Tbody.vue?vue&type=template&id=ec969bba&scoped=true&lang=pug"
import script from "./Tbody.vue?vue&type=script&setup=true&lang=js"
export * from "./Tbody.vue?vue&type=script&setup=true&lang=js"

import "./Tbody.vue?vue&type=style&index=0&id=ec969bba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec969bba"]])

export default __exports__